/**
 * Sync Scales Plugin for uPlot
 * Emits X scale changes to parent for synchronizing zoom across multiple charts
 */

import uPlot from "uplot";

export function syncScalesPlugin(
  onScaleChange: (range: { startTime: number; endTime: number }) => void,
  isInternalUpdate: React.MutableRefObject<boolean>
) {
  return {
    hooks: {
      setScale: [
        (u: uPlot, key: string) => {
          if (key === "x" && !isInternalUpdate.current) {
            const min = u.scales.x.min;
            const max = u.scales.x.max;
            if (min != null && max != null) {
              // Prevent feedback loop
              isInternalUpdate.current = true;
              // Convert from seconds to ms for compatibility with existing interface
              onScaleChange({
                startTime: min * 1000,
                endTime: max * 1000,
              });
              // Reset flag after a short delay
              setTimeout(() => {
                isInternalUpdate.current = false;
              }, 50);
            }
          }
        },
      ],
    },
  };
}
